
import 'fetchpolyfill' ;
import { enableES5 } from 'immer';
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

enableES5();